import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 20,
      lineHeight: '26px',
      color: '#2A394D',
    },
    next: {
      marginLeft: 8,
    },
  },
  {
    name: 'Header',
  },
);

const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('ecBinding:step5')}</div>
    </div>
  );
};

export default Header;
